export enum VehicleDetailsOverviewCard {
  VehicleInformation = 'vehicleInformation',
  VehicleLocation = 'vehicleLocation',
  VehicleRealTimeData = 'vehicleRealTimeData',
  VehicleStateOfCharge = 'vehicleStateOfCharge',
  RecentChargingSessions = 'recentChargingSessions',
  VehicleTrips = 'vehicleTrips',
}
